import { useEffect } from 'react'
import Script from 'next/script'
import posthog from 'posthog-js'
import * as Sentry from '@sentry/browser'
import { User } from '@supabase/supabase-js'
import { debounce } from '@/common/utils'
import { ConsentBanner } from './ConsentBanner'
import { localAPIRequest } from '@/common/request'

const intercomUpdate = debounce(async (data: any) => {
  const { data: hashData } = await localAPIRequest({
    action: 'getHash',
  })

  if (hashData) {
    data.user_hash = hashData
  }

  // @ts-ignore
  window?.Intercom?.('update', data)
}, 500)

export function ChatWidget({ user }: { user?: User | null }) {
  const fullName = `${user?.user_metadata?.name_first || ''} ${
    user?.user_metadata?.name_last || ''
  }`.trim()

  const settings = JSON.stringify({
    app_id: 'afo7k5an',
    api_base: 'https://api-iam.intercom.io',
  })

  useEffect(() => {
    intercomUpdate({
      user_id: user?.id,
      name: fullName || null,
      email: user?.email ?? null,
      created_at: user?.created_at ?? null,
    })

    if (user?.email) {
      Sentry.setUser({ email: user.email })
      posthog.identify(user?.id, { email: user?.email })
    } else {
      Sentry.setUser(null)
    }

    posthog.init('phc_bLa78s5f11Cm2tOHEVZEgIah5jkGgroMCLTqAYIL69H', {
      disable_cookie: true,
      persistence: 'localStorage',
      api_host: 'https://app.posthog.com',
    })
  }, [user?.email])

  return (
    <>
      <ConsentBanner />
      <Script id="chat-widget" strategy="lazyOnload">
        {`
          window.intercomSettings = ${settings};
        (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/afo7k5an';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
        `}
      </Script>
    </>
  )
}
